import { render, staticRenderFns } from "./ReservationsShopTipsPop.vue?vue&type=template&id=1425f1e6&scoped=true&"
import script from "./ReservationsShopTipsPop.vue?vue&type=script&lang=js&"
export * from "./ReservationsShopTipsPop.vue?vue&type=script&lang=js&"
import style0 from "./ReservationsShopTipsPop.vue?vue&type=style&index=0&id=1425f1e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425f1e6",
  null
  
)

export default component.exports